import { MailOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';

export const SendTestMail = ({ send, disabled, style, size, tooltip }) => {
  const email = useSelector((state) => state.auth.user.email);

  const title = useMemo(() => tooltip || `Send test mail to ${email}`, [email, tooltip]);

  return (
    <>
      <Tooltip title={title}>
        <Button style={style} size={size} type="dashed" disabled={disabled} onClick={send}>
          Send test mail <MailOutlined style={{ marginTop: '4px' }} size="small" />
        </Button>
      </Tooltip>
    </>
  );
};
